angular.module('st').controller('SyncDebuggerController', SyncDebuggerController);
SyncDebuggerController.$inject = ['$scope', '$rootScope', '$sce', '$filter', '$http', '$q', '$timeout', '$interval'];

function SyncDebuggerController($scope, $rootScope, $sce, $filter, $http, $q, $timeout, $interval) {
    var sdm = this;
    sdm.buttonSpinner = false;
    sdm.errorMessage = "";
    sdm.successMessage = "";
    sdm.alertCounter = 0;
    sdm.timerSpeed = 8;
    sdm.timermultiplerspeed = 4;
    sdm.alertVariable = 0;
    sdm.overviewWastTimeChecked = null;
    sdm.overviewLastSync = null;
    sdm.overviewLastSyncStart = null;
    sdm.overviewMissingIdsFromVistaCount = null;
    sdm.nonSyncingCount = null;
    sdm.overviewCinemas = null;
    sdm.overviewOldCinemas = null;
    sdm.currentSyncStatus = null;
    sdm.lastSyncTimeOld = null;
    sdm.cinemaconcessions = null;
    sdm.adminsettings = null;
    sdm.linkedAccountEmail = null;
    sdm.mylinkedaccounts = null;
    sdm.linkedtome = null;
    sdm.btsubscription = null;
    sdm.btsubscriptionid = null;

    const timer = ms => new Promise(res => setTimeout(res, ms));
    sdm.CINEMA_KEY = [{
        "id": "001",
        "name": "",
        "enabled": false,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "002",
        "name": "GR North",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "003",
        "name": "Crossroads",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "004",
        "name": "GR South",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "005",
        "name": "Rivertown",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "006",
        "name": "Lansing",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "007",
        "name": "Benton",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "008",
        "name": "Mt Pleasant",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "009",
        "name": "Carousel",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "010",
        "name": "",
        "enabled": false,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "011",
        "name": "Getty",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "012",
        "name": "Meridian Mall",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }, {
        "id": "013",
        "name": "Studio Park/MT",
        "enabled": true,
        "count": 0,
        "countold": 0,
        "affected": false,
        "old": false,
        "concessionsf": false,
        "concessionsvista": false
    }];

    sdm.showJson = false;
    sdm.showtimeResponse = "awaiting response";
    sdm.tab = 1;
    sdm.lastshowtimes = false;
    sdm.oldshowtimes = null;
    sdm.oldshowtimescount = 0;
    sdm.oldshowtimeCinemas = [];
    sdm.missingshowtimes = null;
    sdm.processingsubscriptions = null;


sdm.isFutureDate = function(date) {
var now = moment();
var date = moment(date);
if (now > date) {
return true;
} else {
return false;
}
console.log('date check');
console.log(date);
}


sdm.getBTSub = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }
        if (!sdm.btsubscriptionid) {
            sdm.errorMessage ="Enter BT Sub ID";
        }
        sdm.btsubscription = null;

        getBTSubscription(sdm.btsubscriptionid)
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        console.log(p);
                        sdm.btsubscription = p;
                            
                    } else {
                        sdm.errorMessage = "Failed to get bt subscription";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the vip signups request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
}

    sdm.getVIPClass = function(user) {

        var btCount = 0;
        var vipCount = user.vippoints;

        _.forOwn(user.sub, function(value, key) { 
            if (value) {
                ++btCount;
            }
        });

        if (btCount !== vipCount) {
            return "problem";
        } else {
            return "okay";
        }
    }

    sdm.getVIPSignUpsFn = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }
        sdm.processingsubscriptions = null;

        getVIPSignUps()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        console.log(p);
                        sdm.processingsubscriptions = p;
                            
                    } else {
                        sdm.errorMessage = "Failed to get vip signups";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the vip signups request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.setTab = function(newTab) {
        sdm.tab = newTab;
    };

    sdm.isSet = function(tabNum) {
        return sdm.tab === tabNum;
    };

    sdm.esttime = function(time) {
     return moment(time).tz('America/New_York').format('MM/DD/YYY h:mm A');
    }

    sdm.alertTimer = async function() {
        //console.log('start timer');
        for (sdm.alertVariable = 0; sdm.alertVariable <= sdm.timerSpeed * sdm.timermultiplerspeed; sdm.alertVariable++) {
            var multiplier = sdm.alertVariable === 0 ? 0 : (100 / (sdm.timerSpeed * sdm.timermultiplerspeed));
            var percent = 100 - (sdm.alertVariable * multiplier);
            //console.log(sdm.alertVariable, multiplier, percent);
            $scope.$applyAsync(sdm.alertCounter = percent);
            if (percent === 0) {
                $timeout(function() {
                    $scope.$applyAsync(sdm.errorMessage = null);
                    $scope.$applyAsync(sdm.successMessage = null);
                }, 1000 / sdm.timermultiplerspeed);
            }
            await timer(1000 / sdm.timermultiplerspeed);
        }
    }

    $scope.$watch('sdm.errorMessage', function(newValue, oldValue) {
        if (newValue) {
            sdm.alertTimer();
            // $timeout(function() {
            //     $scope.$applyAsync(sdm.errorMessage = null);
            // }, sdm.timerSpeed * 1000);
        }
    }, true);
    $scope.$watch('sdm.successMessage', function(newValue, oldValue) {
        if (newValue) {
            sdm.alertTimer();
            // $timeout(function() {
            //     $scope.$applyAsync(sdm.successMessage = null);
            // }, sdm.timerSpeed * 1000);
        }
    }, true);

    sdm.bytetomb = function(byte) {
        var mb = byte /1000000;
        var mbceil = Math.ceil(mb);
        var mbstring = String(mbceil).replace(/(.)(?=(\d{3})+$)/g,'$1,');
        return mbstring + " MB";
    }

    sdm.getAdminSettings = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }
        sdm.adminsettings =  null;
        getAdminSettings()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.adminsettings = p;
                        console.log(p);
                    } else {
                        sdm.errorMessage = "Failed to get admin settings.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the admin settings request. Contact support.';
            })
            .finally(function(response) {

            });
    }

    getCinemaConcessionStatus = function() {
        getCinemaConcessions()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    console.log(r);
                    var p = JSON.parse(r);
                    if (p) {
                        sdm.cinemaconcessions = p;
                        _.each(sdm.cinemaconcessions, function(cinema) {
                            let index = _.findIndex(sdm.CINEMA_KEY, function(i) { return i.id === cinema.id })
                            if (index < 0) {
                                return;
                            }
                            sdm.CINEMA_KEY[index].concessionsf = cinema.enabledsf;
                            sdm.CINEMA_KEY[index].concessionsvista = cinema.enabledvista;
                        });
                        console.log(p);
                    } else {
                        sdm.errorMessage = "Failed to get cinema concessions.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the cinema concessions request. Contact support.';
            })
            .finally(function(response) {

            });
    }


    sdm.overViewStats = function() {
        sdm.clearOverviewStats();

        getCinemaConcessionStatus();

        //get missing showtimes, only look at vistas though
        getMissingShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var successFlag = response.data.Success;
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p && successFlag) {
                        sdm.overviewMissingIdsFromVistaCount = p.vistaidsnotinsf.length;
                        var cinemasObj = _.countBy(_.flatMap(p.vistaidsnotinsf, (id) => id.split('-')[0]));

                        sdm.overviewCinemas = Object.keys(cinemasObj).map(key => ({ count: cinemasObj[key], id: key }));
                        _.each(sdm.overviewCinemas, function(cinema) {
                            let index = _.findIndex(sdm.CINEMA_KEY, function(i) { return i.id === cinema.id })
                            if (index < 0) {
                                return;
                            }
                            sdm.CINEMA_KEY[index].affected = true;
                            sdm.CINEMA_KEY[index].count = cinema.count;
                        });
                    } else {
                        sdm.errorMessage = "Failed to get missing showtime count.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the missing showtimes request. Contact support.';
            })
            .finally(function(response) {

            });


        getCurrentSyncingAndLastSync()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        var currentlysyncing = p.currentlysyncing;
                        sdm.overviewLastSync = p.lastsynctime;
                        sdm.overviewLastSyncStart = p.lastsyncstart;

                        //if last sync was less than hour ago, then lastSyncTimeOld is false, as it was recent.
                        if (moment(p.lastsynctime).isAfter(moment().subtract(1, 'hours'))) {
                            sdm.lastSyncTimeOld = false;
                        } else {
                            sdm.lastSyncTimeOld = true;
                        }

                        var syncstopped = p.syncstopped;

                        sdm.currentSyncStatus = currentlysyncing;
                    } else {
                        sdm.errorMessage = "Failed to get currently syncing status";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'Failed to get currently syncing status.';
            })
            .finally(function(response) {

            });



        getLastSyncShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    if (p) {
                        let result = Object.keys(p).map(key => ({
                            id: key,
                            value: p[key]
                        }));
                        sdm.oldshowtimes = result;
                        sdm.nonSyncingCount = Object.keys(sdm.oldshowtimes).length

                        //var cinemasObj = _.countBy(_.flatMap(Object.keys(result), (id) => id.split('-')[0]));
                        var cinemasObj = _.countBy(_.flatMap(result, (x) => x.id.split('-')[0]));

                        sdm.overviewOldCinemas = Object.keys(cinemasObj).map(key => ({ count: cinemasObj[key], id: key }));

                        _.each(sdm.overviewOldCinemas, function(cinema) {
                            let index = _.findIndex(sdm.CINEMA_KEY, function(i) { return i.id === cinema.id })
                            if (index < 0) {
                                return;
                            }
                            sdm.CINEMA_KEY[index].old = true;
                            sdm.CINEMA_KEY[index].countold = cinema.count;
                        });
                    } else {
                        sdm.errorMessage = "Failed to get last sync showtimes.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'Failed to get last sync showtimes';
            })
            .finally(function(response) {});


        sdm.overviewWastTimeChecked = moment().tz('America/New_York').format('MM/DD h:mm A');
    }

    sdm.formatBytes = function(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    sdm.TimeSince = function(t) {
        return moment(t).fromNow()
    }


    sdm.ToTheTop = function(id) {
        $scope.$applyAsync(sdm.showtimeLookupID = id);
        sdm.lookupShowtime();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    re = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/


    sdm.buttonLocksAndMessage = function() {
        if (sdm.buttonSpinner) {
            return true;
        } else {
            $scope.$applyAsync(sdm.alertCounter = 100);
            $scope.$applyAsync(sdm.alertVariable = 0);
            sdm.buttonSpinner = true;
            sdm.errorMessage = "";
            sdm.successMessage = "";
            return false;
        }
    }

    sdm.clearOverviewStats = function() {
        sdm.overviewWastTimeChecked = null;
        sdm.overviewLastSync = null;
        sdm.overviewLastSyncStart = null;
        sdm.overviewMissingIdsFromVistaCount = null;
        sdm.nonSyncingCount = null;
        sdm.overviewCinemas = null;
        sdm.currentSyncStatus = null;
        sdm.overviewOldCinemas = null;
        sdm.cinemaconcessions = null;
        sdm.lastSyncTimeOld = null;
        sdm.CINEMA_KEY = [{
            "id": "001",
            "name": "",
            "enabled": false,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "002",
            "name": "GR North",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "003",
            "name": "Crossroads",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "004",
            "name": "GR South",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "005",
            "name": "Rivertown",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "006",
            "name": "Lansing",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "007",
            "name": "Benton",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "008",
            "name": "Mt Pleasant",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "009",
            "name": "Carousel",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "010",
            "name": "",
            "enabled": false,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "011",
            "name": "Getty",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "012",
            "name": "Meridian Mall",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }, {
            "id": "013",
            "name": "Studio Park/MT",
            "enabled": true,
            "count": 0,
            "countold": 0,
            "affected": false,
            "old": false,
            "concessionsf": false,
            "concessionsvista": false
        }];
    }

    sdm.showtimeFormatter = function(value) {
        if (re.test(value) && (value.toString().indexOf("T") >= 0)) {
            return moment(value).tz('America/New_York').format('MM/DD h:mm A');
        } else {
            return value;
        }
    }

    sdm.getmissingshowtimes = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.missingshowtimes = null;

        getMissingShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var successFlag = response.data.Success;
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    console.log(p);
                    if (p && successFlag) {
                        sdm.successMessage = "Success! (if empty, then no old showtimes)";
                        sdm.missingshowtimes = p;
                    } else {
                        sdm.errorMessage = "Failed to get missing showtimes.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the missing showtimes request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.CinemaFormatter = function(ary) {
        return ary.join(", ");
    }

    sdm.getlastsyncshowtimes = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.oldshowtimes = null;
        sdm.oldshowtimescount = 0;
        sdm.oldshowtimeCinemas = [];

        getLastSyncShowtimes()
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);
                    console.log(p);
                    if (p) {
                        sdm.successMessage = "Success! (if empty, then no old showtimes)";
                        let result = Object.keys(p).map(key => ({
                            id: key,
                            value: p[key]
                        }));
                        sdm.oldshowtimes = result;
                        sdm.oldshowtimescount = Object.keys(sdm.oldshowtimes).length
                        sdm.oldshowtimeCinemas = _.uniq(_.flatMap(sdm.oldshowtimes, ({ id }) => id.split('-')[0]));
                    } else {
                        sdm.errorMessage = "Failed to get last sync showtimes.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the last sync showtimes request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }


    sdm.forceSyncShowtime = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }


        showtimeSync(sdm.showtimeLookupID)
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);

                    if (p) {
                        sdm.successMessage = "Synced into Sitefinity. You may lookup again.";
                    } else {
                        sdm.errorMessage = "Failed to syn the showtime sync into Sitefinity.";
                    }
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the showtimesync request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.init = function() {
        sdm.overViewStats();
    }

    sdm.lookupLinkedAccounts = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.linkedtome = null;
        sdm.mylinkedaccounts = null;

        if (!sdm.linkedAccountEmail) {
            sdm.errorMessage = 'no email entered';
            sdm.buttonSpinner = false;
            return;
        }


        getLinkedAccounts(sdm.linkedAccountEmail)
            .then(function(response) {
                if (response && response.data) {
                    if (!response.data.Success) {
                        
                        sdm.errorMessage = response.data.Message || 'something went wrong with the VIP lookup request. Contact support.';   
                        sdm.buttonSpinner = false;    
                        return;                 
                    }

                    var r = response.data.Data;
                    var p = JSON.parse(r);  

                    sdm.mylinkedaccounts = p.mylinkedaccounts;

                    if (p.linkedtome) {
                        sdm.linkedtome = _.remove(p.linkedtome, function(n) {
                            return n.Email.toLowerCase() !== sdm.linkedAccountEmail.toLowerCase();
                        });
                    } else {
                        sdm.linkedtome = p.linkedtome;
                    }

                    sdm.successMessage = 'found links!';
                        $(function () {
                              $('[data-toggle="tooltip"]').tooltip()
                        });
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the VIP lookup request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    }

    sdm.lookupShowtime = function() {
        if (sdm.buttonLocksAndMessage()) {
            return;
        }

        sdm.sitefinityResponseString = sdm.showtimeResponse;
        sdm.vistaResponseString = sdm.showtimeResponse;
        sdm.sitefinityResponse = null;
        sdm.vistaResponse = null;

        if (!sdm.showtimeLookupID) {
            sdm.errorMessage = 'no id entered';
            sdm.buttonSpinner = false;
            return;
        }

        showtimeLookup(sdm.showtimeLookupID)
            .then(function(response) {
                if (response && response.data) {
                    var r = response.data.Data;
                    var p = JSON.parse(r);                    

                    sdm.sitefinityResponseString = p.sitefinityjson;
                    sdm.vistaResponseString = p.vistajson;

                    sdm.vistaResponse = JSON.parse(p.vistajson);
                    sdm.sitefinityResponse = JSON.parse(p.sitefinityjson);

                    sdm.sitefinityResponse['Date Created'] = p['sfDateCreated'] || null;
                    sdm.sitefinityResponse['Last Synced'] = p['sfLastModified'] || null;

                    if (p.filmname) {
                         sdm.sitefinityResponse['Event/Film'] = p.filmname;                        
                    }

                    var combinederror = "";
                    if (sdm.vistaResponse['message']) {
                        combinederror += sdm.vistaResponse['message'] + " ";
                    }
                    if (sdm.sitefinityResponse['message']) {
                        combinederror += sdm.sitefinityResponse['message'];
                    }
                    if (combinederror) {
                        sdm.errorMessage = combinederror;
                    }
                    sdm.successMessage = 'found showtimes!';
                }
            })
            .catch(function(response) {
                sdm.errorMessage = 'something went wrong with the showtime lookup request. Contact support.';
            })
            .finally(function(response) {
                sdm.buttonSpinner = false;
            });
    };

    function getCurrentSyncingAndLastSync() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/syncstats", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getAdminSettings() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/adminsettings", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getLinkedAccounts(lookupemail) {
        var config = {
            params: {
                email: lookupemail
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/linkedvipusers", config).then(deferred.resolve);
        return deferred.promise;
    }

    function showtimeLookup(showtimeid) {
        var config = {
            params: {
                id: showtimeid
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimes", config).then(deferred.resolve);
        return deferred.promise;
    }

    function showtimeSync(showtimeid) {
        var config = {
            params: {
                id: showtimeid
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimesync", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getLastSyncShowtimes() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimesmodified", config).then(deferred.resolve);
        return deferred.promise;
    }

function getBTSubscription(btid) {
        var config = {
            params: {
                id: btid
            }
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/btsubscription", config).then(deferred.resolve);
        return deferred.promise;
    }

function getVIPSignUps() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/vipsignups", config).then(deferred.resolve);
        return deferred.promise;
    }


    function getMissingShowtimes() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/showtimesmissing", config).then(deferred.resolve);
        return deferred.promise;
    }

    function getCinemaConcessions() {
        var config = {
            params: {}
        };
        var deferred = $q.defer();

        $http.get("/rpc/debugger/cinemaconcessions", config).then(deferred.resolve);
        return deferred.promise;
    }


    var seconds = 60;
    var minutes = 5;
    var ms = 1000;
    var total = minutes * ms * seconds;
    $interval(sdm.overViewStats, total);
}